
import React from 'react';
import { inject, observer } from "mobx-react";


@inject('languageStore')
@observer
export default class Logo extends React.Component {
  render () {
    const domain = process.env.LOGIN_DOMAIN + (this.props.languageStore.lang === 'en' ? '/en-US' : '/zh-CN')
    return (
      <a className="logo" href={domain}>
       <img alt="logo" src="https://rm-static.djicdn.com/robomasters/public/img/logo.4695cb8.png" />
      </a>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/header/logo.js